import * as L from "leaflet";
import * as GeoJSON from "geojson";

export interface ILeafletClusterState {
  center: L.LatLng;
  zoom: number;
  bbox: GeoJSON.BBox;
}

export const initialLeafletClusterState: ILeafletClusterState = {
  center: new L.LatLng(0, 0),
  zoom: 0,
  bbox: [-180, -85, 180, 85]
}
